import { render, staticRenderFns } from "./SubmissionDetailModal.vue?vue&type=template&id=75424576&scoped=true"
import script from "./SubmissionDetailModal.vue?vue&type=script&lang=js"
export * from "./SubmissionDetailModal.vue?vue&type=script&lang=js"
import style0 from "./SubmissionDetailModal.vue?vue&type=style&index=0&id=75424576&prod&lang=stylus&scoped=true"
import style1 from "./SubmissionDetailModal.vue?vue&type=style&index=1&id=75424576&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75424576",
  null
  
)

export default component.exports